import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
const IoArrowBack = require("react-icons/io5").IoArrowBack;

const DetailQuisioner = () => {
  const { id } = useParams<{ id: string }>(); // presiden_id
  const token = Cookies.get("token");

  const [loading, setLoading] = useState(true);
  const [quisioners, setQuisioners] = useState<any[]>([]);

  // Fetch quisioner list
  const fetchQuisioners = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/presidens/${id}/quisioners`, { headers: { Authorization: `Bearer ${token}` } });
      setQuisioners(res.data.quisioners || []);
    } catch (err) {
      console.error("Gagal fetch quisioners:", err);
      Swal.fire("Error", "Gagal memuat data quisioner.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    fetchQuisioners();
  }, [id, token]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="mt-6 max-w-4xl mx-auto px-4">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6">
        <Link to={`/dashboard/voteKuisioner`} className="flex items-center gap-2 text-primary hover:text-yellow-800 transition">
          <IoArrowBack className="text-xl" />
          <span className="font-medium">Kembali</span>
        </Link>
      </div>

      <h1 className="text-2xl font-bold text-gray-800 mb-6">Detail Vote Quisioner</h1>

      {/* List quisioner */}
      <div className="space-y-4">
        {quisioners.length === 0 ? (
          <div className="text-center py-10 bg-gray-50 border rounded-lg">
            <p className="text-gray-500">Belum ada quisioner 📭</p>
          </div>
        ) : (
          quisioners.map((q) => (
            <div key={q.id} className="border rounded-lg shadow-sm bg-white hover:shadow-md transition p-4">
              <div className="flex flex-col gap-2">
                <input type="text" defaultValue={q.pertanyaan} readOnly className="border border-gray-200 p-3 rounded-md w-full bg-gray-50 font-medium text-gray-800 cursor-not-allowed" />
                <div className="flex justify-start gap-4 text-sm text-gray-600 mt-2">
                  <div className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium">
                    Rata-rata Penilaian: <span className="font-bold">{q.avg_nilai ?? "-"}</span>
                  </div>
                  <div className="bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium">
                    Jumlah Vote: <span className="font-bold">{q.total_vote ?? 0}</span>{" "}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default DetailQuisioner;
